export default __webpack_public_path__ + "static/screen-d02007f88a6e4727eabcf2eef0d7627f.png";